<template>
  <section>
    <h4 v-if="title">{{ title }}</h4>
    <slot />
  </section>
</template>

<script>
export default {
  props: ["title"],
}
</script>

<style lang="scss" scoped>
section {
  margin: 5px 0 20px 0;
  &:last-of-type {
    margin-bottom: 0;
  }
  h4 {
    margin: 0px 0 7px 0;
    font-size: 0.8rem;
  }
}
</style>
